$(document).ready(function() {
    $('#categoria-noticia').find('li').on('click', function(){
        window.location.href = url_base + '/noticias/?categoria=' + encodeURI($(this).data('value'));
    });
});
